import { TOSIPTypes } from '../../domain/tos.ip';
import { AddTOSBaseRequest } from './add.tos.base.request';

export class AddTOSIPRequest extends AddTOSBaseRequest {

    AdminID: number;

    IP: string;
    IPType: TOSIPTypes;

    MemberID: number;


}
